import ApiBase from '../ApiBase';

class PushNotifications extends ApiBase {
    route = '/admin/push-notifications';
}

export default new PushNotifications();
